import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ResponseStatus } from "../../actions/types";
import {
    handleGetNotifications,
    handleGetNotificationsCount,
    handleGetNotificationTemplates,
    NotificationModel,
    NotificationTemplate,
    onPaginationChange
} from "../reducers/user-notifications.reducer";
import notificationTemplateService from "../../services/notification-template-service";
import notificationService from "../../services/notificaions-service";

export const getNotifications = createAsyncThunk(
    'getNotifications',
    async (props: { filter: object, page: number }, thunkApi) => {
        try {
            const notifications = await notificationService.getMyNotifications(props.filter, props.page);
            return { notifications }
        } catch (error) {
            return {
                errors: thunkApi.rejectWithValue(error)
            }
        }
    }
)

export const getNotificationById = createAsyncThunk(
    'getNotificationById',
    async (notificationId: number | undefined, thunkApi) => {
        try {
            const notification = await notificationService.getNotificationById(notificationId);
            return { notification }
        } catch (error) {
            return {
                errors: thunkApi.rejectWithValue(error)
            }
        }
    }
)

export const updateNotificationsById = createAsyncThunk(
    'updateNotificationsById',
    async (props: { notificationId: number[] | undefined, data: object }, thunkApi) => {
        try {
            const notification = await notificationService.updateNotificationsById(props.notificationId, props.data);
            return { notification }
        } catch (error) {
            return {
                errors: thunkApi.rejectWithValue(error)
            }
        }
    }
)

export const getNotificationsCount = createAsyncThunk(
    'getNotificationsCount',
    async (includeUnread: boolean, thunkApi) => {
        try {
            return await notificationService.getNotificationsCount(includeUnread);
        } catch (error) {
            return {
                errors: thunkApi.rejectWithValue(error)
            }
        }
    }
)

export const getNotificationTemplates = createAsyncThunk(
    'getNotificationTemplates',
    async (filter: object, thunkApi) => {
        try {
            const notificationTemplates = await notificationTemplateService.getNotificationTemplates(filter);
            return { notificationTemplates: notificationTemplates }
        } catch (error) {
            return {
                access_token: null,
                errors: thunkApi.rejectWithValue(error)
            }
        }
    }
)

export const userNotificationsSlice = createSlice({
    name: "userNotifications",
    initialState: {
        notificationsData: {
            userNotifications: [] as NotificationModel[],
            currentPage: 0,
            pageSize: 8,
            totalItems: 0,
        },
        notificationData: null,
        notificationsCount: 0,
        statusNotificationTemplates: {
            templates: [] as NotificationTemplate[],
            currentPage: 0,
            pageSize: 50,
            totalItems: 0,
            templateType: 1,
        },
        transactionNotificationTemplates: {
            templates: [] as NotificationTemplate[],
            currentPage: 0,
            pageSize: 50,
            totalItems: 0,
            templateType: 2,
        },
        userNotificationConfigs: {},
        errors: [],
        isLoading: false,
    } as UserNotificationsSliceData,
    reducers: {
        changePagination: onPaginationChange,
    },
    extraReducers: (builder) => {
        builder.addCase(getNotificationTemplates.pending, state => handleGetNotificationTemplates(state, ResponseStatus.PENDING, null));
        builder.addCase(getNotificationTemplates.fulfilled, (state, action) => handleGetNotificationTemplates(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getNotificationTemplates.rejected, (state, action) => handleGetNotificationTemplates(state, ResponseStatus.FAIL, action.payload));
        builder.addCase(getNotifications.pending, state => handleGetNotifications(state, ResponseStatus.PENDING, null));
        builder.addCase(getNotifications.fulfilled, (state, action) => handleGetNotifications(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getNotifications.rejected, (state, action) => handleGetNotifications(state, ResponseStatus.FAIL, action.payload));
        builder.addCase(getNotificationById.pending, state => handleGetNotifications(state, ResponseStatus.PENDING, null));
        builder.addCase(getNotificationById.fulfilled, (state, action) => handleGetNotifications(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getNotificationById.rejected, (state, action) => handleGetNotifications(state, ResponseStatus.FAIL, action.payload));
        builder.addCase(getNotificationsCount.pending, state => handleGetNotificationsCount(state, ResponseStatus.PENDING, null));
        builder.addCase(getNotificationsCount.fulfilled, (state, action) => handleGetNotificationsCount(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getNotificationsCount.rejected, (state, action) => handleGetNotificationsCount(state, ResponseStatus.FAIL, action.payload));
    }
})

export interface UserNotificationsSliceData {
    notificationsData: {
        userNotifications: NotificationModel[],
        currentPage: number,
        pageSize: number,
        totalItems: number,
    },
    notificationData: NotificationModel | null,
    notificationsCount: number,
    statusNotificationTemplates: {
        templates: NotificationTemplate[],
        currentPage: number,
        pageSize: number,
        totalItems: number,
    },
    transactionNotificationTemplates: {
        templates: NotificationTemplate[],
        currentPage: number,
        pageSize: number,
        totalItems: number,
    },
    userNotificationConfigs: any;
    errors: any[],
    isLoading: boolean,
}

export default userNotificationsSlice.reducer;
export const { changePagination } = userNotificationsSlice.actions;
